import { render, staticRenderFns } from "./quill.vue?vue&type=template&id=1607afa0&scoped=true"
import script from "./quill.vue?vue&type=script&lang=js"
export * from "./quill.vue?vue&type=script&lang=js"
import style0 from "./quill.vue?vue&type=style&index=0&id=1607afa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1607afa0",
  null
  
)

export default component.exports